import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios';
import { BASE_URL3 } from '../../config/axios';
import { Modal } from 'react-bootstrap';
import { AddwithWhiteCircle, UpdatePencil } from '../../components/AllSvg';
import { handleErrorToast } from '../../components/CustomFunctions';
import {
    UserRound, X, Save, Loader, AlertCircle, BadgeCheck,
    Phone, Mail, Trash2, AlertTriangle,
    SectionIcon,
    Search
} from "lucide-react";
import { AddModalButton, DeleteModalButton, UpdateModalButton } from '../../components/DynamicButtons';

// const AddAuthorityDetail = ({ getAuthorityDetail }) => {
//     const [errors, setErrors] = useState({});
//     const [show, setShow] = useState(false);

//     const [formData, setFormData] = useState({
//         bank_name: '',
//         designation: '',
//         mobile_no: '',
//         email: ''
//     });

//     const handleShow = () => setShow(true);
//     const handleClose = () => setShow(false);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };

//     const validateform = () => {
//         const newErrors = {};
//         const requiredFields = ["bank_name", "designation", "mobile_no", "email"];

//         requiredFields.forEach((field) => {
//             if (!formData[field]?.trim()) {
//                 newErrors[field] = `This field is required!`;
//             }
//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         if (validateform()) {
//             const loadingToastId = toast.loading("Loading: Please wait...");
//             try {

//                 const res = await axios.post(`${BASE_URL3}/project/authoritydetails/`, formData);

//                 if (res.status === 201 || res.status === 200) {
//                     toast.success("Project name added successfully!");
//                     setShow(false);
//                     setFormData({
//                         bank_name: '',
//                         designation: '',
//                         mobile_no: '',
//                         email: ''
//                     });
//                     getAuthorityDetail();
//                 }
//             } catch (err) {
//                 console.error("Error adding project name:", err);
//                 if (err.response?.data) {
//                     toast.error(`Failed to add project name: ${JSON.stringify(err.response.data)}`);
//                 } else {
//                     toast.error("Failed to add project name");
//                 }
//             } finally {
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };



//     return (
//         <>
//             <button
//                 title="Add Division"
//                 className="upload-svg"
//                 onClick={handleShow}
//             >
//                 <AddwithWhiteCircle /> Authority
//             </button>

//             <Modal
//                 show={show}
//                 onHide={handleClose}
//                 dialogClassName="request-leave"
//             >
//                 <Modal.Header
//                     closeButton
//                     className="justify-center task-Tab-heading font-weight500 font-size-heading"
//                 >
//                     <Modal.Title>Add Authority Detail</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body>
//                     <form className="add-activity" onSubmit={handleFormSubmit}>
//                         <div className="parent-div">
//                             <div className="bdy-div">
//                                 <div title="name" className="flex-column">
//                                     <label
//                                         htmlFor="bank_name"
//                                         className="form-labels font-weight500 font-size-subheading"
//                                     >
//                                         Name<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         id="bank_name"
//                                         name="bank_name"
//                                         placeholder="Enter Name"
//                                         onChange={handleInputChange}
//                                         value={formData.bank_name}
//                                         className={`form-input  ${errors.bank_name ? "input-error" : ""}`}

//                                     />
//                                     {errors.bank_name && (
//                                         <span className="error-message font-size-text">
//                                             {errors.bank_name}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div title="Designation" className="flex-column">
//                                     <label
//                                         htmlFor="designation"
//                                         className="form-labels font-weight500 font-size-subheading"
//                                     >
//                                         Designation<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         id="designation"
//                                         name="designation"
//                                         placeholder="Designation Name"
//                                         onChange={handleInputChange}
//                                         value={formData.designation}
//                                         className={`form-input  ${errors.designation ? "input-error" : ""}`}

//                                     />
//                                     {errors.designation && (
//                                         <span className="error-message font-size-text">
//                                             {errors.designation}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div title="Mobile no." className="flex-column">
//                                     <label
//                                         htmlFor="mobile_no"
//                                         className="form-labels font-weight500 font-size-subheading"
//                                     >
//                                         Mobile No.<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="number"
//                                         id="mobile_no"
//                                         name="mobile_no"
//                                         placeholder="Mobile no"
//                                         onChange={handleInputChange}
//                                         value={formData.mobile_no}
//                                         className={`form-input  ${errors.mobile_no ? "input-error" : ""}`}

//                                     />
//                                     {errors.mobile_no && (
//                                         <span className="error-message font-size-text">
//                                             {errors.mobile_no}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div title="Email" className="flex-column">
//                                     <label
//                                         htmlFor="email"
//                                         className="form-labels font-weight500 font-size-subheading"
//                                     >
//                                         Email<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="mail"
//                                         id="email"
//                                         name="email"
//                                         placeholder="Email"
//                                         onChange={handleInputChange}
//                                         value={formData.email}
//                                         className={`form-input  ${errors.email ? "input-error" : ""}`}

//                                     />
//                                     {errors.email && (
//                                         <span className="error-message font-size-text">
//                                             {errors.email}
//                                         </span>
//                                     )}
//                                 </div>

//                             </div>

//                             {/* Submit Button */}
//                             <div className="button-models" style={{ width: '100%' }}>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit"
//                                 >
//                                     Add
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

// const UpdateAuthorityDetail = ({ i, getAuthorityDetail }) => {
//     const [errors, setErrors] = useState({});
//     const [show, setShow] = useState(false);

//     const [formData, setFormData] = useState({
//         bank_name: '',
//         designation: '',
//         mobile_no: '',
//         email: ''
//     });

//     const handleShow = () => {
//         setShow(true);
//         setFormData(i);
//     }
//     const handleClose = () => setShow(false);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData((prevData) => ({
//             ...prevData,
//             [name]: value,
//         }));
//     };

//     const validateform = () => {
//         const newErrors = {};
//         const requiredFields = ["bank_name", "designation", "mobile_no", "email"];

//         requiredFields.forEach((field) => {
//             const value = formData[field];
//             if (!String(value || "").trim()) {
//                 newErrors[field] = `This field is required!`;
//             }
//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         if (validateform()) {
//             const loadingToastId = toast.loading("Loading: Please wait...");
//             try {

//                 const res = await axios.put(`${BASE_URL3}/project/authoritydetailsupdate/${i.id}/`,
//                     {
//                         bank_name: formData.bank_name,
//                         designation: formData.designation,
//                         mobile_no: formData.mobile_no,
//                         email: formData.email,
//                     }
//                 );

//                 if (res.status === 201 || res.status === 200) {
//                     toast.success("Project name updated successfully!");
//                     setShow(false);
//                     setFormData({
//                         bank_name: '',
//                         designation: '',
//                         mobile_no: '',
//                         email: ''
//                     });
//                     getAuthorityDetail();
//                 }
//             } catch (err) {
//                 console.error("Error updating project name:", err);
//                 if (err.response?.data) {
//                     toast.error(`Failed to update project name: ${JSON.stringify(err.response.data)}`);
//                 } else {
//                     toast.error("Failed to update project name");
//                 }
//             } finally {
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };

//     return (
//         <>
//             <button
//                 title="Update Project Name"
//                 className="model-edit-button"
//                 onClick={handleShow}
//             >
//                 <UpdatePencil />
//             </button>

//             <Modal
//                 show={show}
//                 onHide={handleClose}
//                 dialogClassName="request-leave"
//             >
//                 <Modal.Header
//                     closeButton
//                     className="justify-center task-Tab-heading font-weight500 font-size-heading"
//                 >
//                     <Modal.Title>Update Authority Detail</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body>
//                     <form className="add-activity" onSubmit={handleFormSubmit}>
//                         <div className="parent-div">
//                             <div className="bdy-div">
//                                 <div title="name" className="flex-column">
//                                     <label
//                                         htmlFor="bank_name"
//                                         className="form-labels font-weight500 font-size-subheading"
//                                     >
//                                         Name<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         id="bank_name"
//                                         name="bank_name"
//                                         placeholder="Enter Name"
//                                         onChange={handleInputChange}
//                                         value={formData.bank_name}
//                                         className={`form-input  ${errors.bank_name ? "input-error" : ""}`}

//                                     />
//                                     {errors.bank_name && (
//                                         <span className="error-message font-size-text">
//                                             {errors.bank_name}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div title="Designation" className="flex-column">
//                                     <label
//                                         htmlFor="designation"
//                                         className="form-labels font-weight500 font-size-subheading"
//                                     >
//                                         Designation<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="text"
//                                         id="designation"
//                                         name="designation"
//                                         placeholder="Designation Name"
//                                         onChange={handleInputChange}
//                                         value={formData.designation}
//                                         className={`form-input  ${errors.designation ? "input-error" : ""}`}

//                                     />
//                                     {errors.designation && (
//                                         <span className="error-message font-size-text">
//                                             {errors.designation}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div title="Mobile no." className="flex-column">
//                                     <label
//                                         htmlFor="mobile_no"
//                                         className="form-labels font-weight500 font-size-subheading"
//                                     >
//                                         Mobile No.<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="number"
//                                         id="mobile_no"
//                                         name="mobile_no"
//                                         placeholder="Mobile no"
//                                         onChange={handleInputChange}
//                                         value={formData.mobile_no}
//                                         className={`form-input  ${errors.mobile_no ? "input-error" : ""}`}

//                                     />
//                                     {errors.mobile_no && (
//                                         <span className="error-message font-size-text">
//                                             {errors.mobile_no}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div title="Email" className="flex-column">
//                                     <label
//                                         htmlFor="email"
//                                         className="form-labels font-weight500 font-size-subheading"
//                                     >
//                                         Email<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         type="mail"
//                                         id="email"
//                                         name="email"
//                                         placeholder="Email"
//                                         onChange={handleInputChange}
//                                         value={formData.email}
//                                         className={`form-input  ${errors.email ? "input-error" : ""}`}

//                                     />
//                                     {errors.email && (
//                                         <span className="error-message font-size-text">
//                                             {errors.email}
//                                         </span>
//                                     )}
//                                 </div>

//                             </div>

//                             {/* Submit Button */}
//                             <div className="button-models" style={{ width: '100%' }}>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit"
//                                 >
//                                     Update
//                                 </button>
//                             </div>
//                         </div>
//                     </form>
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

// const DeleteAuthorityDetail = ({ i, getAuthorityDetail }) => {
//     const [show, setShow] = useState(false);

//     const handleShow = () => {
//         setShow(true)
//     }

//     const handleFormSubmitDelete = async (e) => {
//         e.preventDefault();
//         const loadingToastId = toast.loading("Loading: Please wait...");

//         try {
//             let res = await axios.delete(
//                 `${BASE_URL3}/project/authoritydetailsupdate/${i.id}/`
//             );

//             if (res.status === 200) {
//                 toast.success(`Data deleted successfully`);
//                 await getAuthorityDetail(); // refresh table
//                 setShow(false);
//             }
//         } catch (err) {
//             toast.error("Failed to delete data");
//             console.error(err);
//         } finally {
//             toast.dismiss(loadingToastId);
//         }
//     };

//     return (
//         <>
//             <button
//                 title="Delete Project Name"
//                 className="model-delete-button"
//                 onClick={handleShow}
//             >
//                 <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="18"
//                     height="18"
//                     viewBox="0 0 18 18"
//                     fill="none"
//                 >
//                     <path
//                         d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
//                         fill="#F72B50"
//                     />
//                 </svg>
//             </button>

//             <Modal
//                 show={show}
//                 onHide={() => setShow(false)}
//                 dialogClassName="request-leave width-40vw"
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>
//                         Delete Authority Detail: {i.bank_name}
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <p>
//                         Are you sure you want to delete{" "}
//                         <strong>{i.name}</strong>?
//                     </p>
//                     <div className="button-models">
//                         <button
//                             className="model-button model-button-cancel"
//                             onClick={() => setShow(false)}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             onClick={handleFormSubmitDelete}
//                             className="model-button model-button-delete"
//                         >
//                             Delete
//                         </button>
//                     </div>
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };


const AuthorityCU = ({ getAuthorityDetail, usedFor = "Add", i }) => {
    const isAdd = usedFor === "Add";

    const initialForm = {
        bank_name: "",   // backend field: authority ka naam
        designation: "",
        mobile_no: "",
        email: "",
    };

    const [formData, setFormData] = useState(initialForm);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const handleShow = () => {
        if (!isAdd && i) {
            setFormData({
                bank_name: i.bank_name ?? "",
                designation: i.designation ?? "",
                mobile_no: i.mobile_no ?? "",
                email: i.email ?? "",
            });
        }
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setFormData(initialForm);
        setErrors({});
        setInputState({});
    };

    const fields = [
        { name: "bank_name", label: "Name", icon: UserRound, placeholder: "e.g. Mr. Rajesh Kumar", type: "text" },
        { name: "designation", label: "Designation", icon: BadgeCheck, placeholder: "e.g. Project Manager", type: "text" },
        { name: "mobile_no", label: "Mobile No.", icon: Phone, placeholder: "e.g. 9876543210", type: "tel", inputMode: "numeric" },
        { name: "email", label: "Email", icon: Mail, placeholder: "e.g. name@company.com", type: "email" },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setInputState((prev) => ({ ...prev, [name]: value }));
        if (String(value).trim()) {
            setErrors((prev) => {
                const updated = { ...prev };
                delete updated[name];
                return updated;
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};
        fields.forEach((f) => {
            if (!String(formData[f.name] ?? "").trim()) {
                newErrors[f.name] = `${f.label} is required!`;
            }
        });
        if (formData.email && !/^\S+@\S+\.\S+$/.test(formData.email.trim())) {
            newErrors.email = "Enter a valid email address!";
        }
        if (formData.mobile_no && !/^\d{10}$/.test(String(formData.mobile_no).trim())) {
            newErrors.mobile_no = "Enter a valid 10 digit mobile number!";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e?.preventDefault?.();
        if (!validateForm()) return;

        const loadingToastId = toast.loading("Loading: Please wait...");
        setLoading(true);
        try {
            const res = isAdd
                ? await axios.post(`${BASE_URL3}/project/authoritydetails/`, formData)
                : await axios.put(`${BASE_URL3}/project/authoritydetailsupdate/${i.id}/`, formData);

            if (res.status === 200 || res.status === 201) {
                toast.dismiss(loadingToastId);
                toast.success(`Authority detail ${isAdd ? "added" : "updated"} successfully!`);
                handleClose();
                getAuthorityDetail();
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const errorCount = Object.keys(errors).length;

    return (
        <>
            {isAdd ? (
                <AddModalButton title="Add Authority Details" onClick={handleShow} />

            ) : (
                <UpdateModalButton title="Update Authority Details" onClick={handleShow} />
            )}

            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
                {/* ===== HEADER ===== */}
                <Modal.Header className="modern-modal-header">
                    <div className="header-content">
                        <div className="header-icon-wrapper">
                            <UserRound size={24} />
                        </div>
                        <div>
                            <Modal.Title>{isAdd ? "Add" : "Update"} Authority Detail</Modal.Title>
                            <p className="header-subtitle">
                                {isAdd
                                    ? "Fill in the details to add a new authority"
                                    : "Edit the details of this authority"}
                            </p>
                        </div>
                    </div>
                    <button type="button" className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                {/* ===== BODY ===== */}
                <Modal.Body className="modern-modal-body">
                    <form onSubmit={handleSubmit} className="project-form">
                        <div className="form-section animate-fade-in">
                            <div className="section-title">
                                <SectionIcon icon={UserRound} color="#10b981" />
                                <div>
                                    <h4>Authority Information</h4>
                                    <p className="section-subtitle">Name, designation and contact details</p>
                                </div>
                            </div>

                            <div className="form-grid">
                                {fields.map((f) => {
                                    const Icon = f.icon;
                                    return (
                                        <div key={f.name} className="form-field">
                                            <label htmlFor={f.name}>
                                                <Icon size={14} /> {f.label}<span className="required">*</span>
                                            </label>
                                            <input
                                                id={f.name}
                                                type={f.type}
                                                inputMode={f.inputMode}
                                                name={f.name}
                                                value={formData[f.name]}
                                                placeholder={f.placeholder}
                                                onChange={handleInputChange}
                                                className={errors[f.name] ? "error" : inputState[f.name] ? "success" : ""}
                                            />
                                            {errors[f.name] && (
                                                <span className="error-message">
                                                    <AlertCircle size={12} /> {errors[f.name]}
                                                </span>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </form>
                </Modal.Body>

                {/* ===== FOOTER ===== */}
                <Modal.Footer className="modern-modal-footer">
                    <div>
                        {errorCount > 0 && (
                            <div className="tab-error-message">
                                <AlertCircle size={14} />
                                <span>{errorCount > 1 ? `${errorCount} fields need attention` : "1 field needs attention"}</span>
                            </div>
                        )}
                    </div>
                    <div className="submit-buttons">
                        <button type="button" className="btn-secondaryy" onClick={handleClose}>
                            Cancel
                        </button>
                        <button type="button" className="btn-primaryy" disabled={loading} onClick={handleSubmit}>
                            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                            <span>
                                {loading
                                    ? (isAdd ? "Adding..." : "Updating...")
                                    : (isAdd ? "Add Authority" : "Update Authority")}
                            </span>
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

/* Purane naam se use karo, parent me change nahi */
const AddAuthorityDetail = ({ getAuthorityDetail }) => (
    <AuthorityCU usedFor="Add" getAuthorityDetail={getAuthorityDetail} />
);

const UpdateAuthorityDetail = ({ i, getAuthorityDetail }) => (
    <AuthorityCU usedFor="Update" i={i} getAuthorityDetail={getAuthorityDetail} />
);

/* ===================== DELETE ===================== */
const DeleteAuthorityDetail = ({ i, getAuthorityDetail }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            const res = await axios.delete(`${BASE_URL3}/project/authoritydetailsupdate/${i.id}/`);

            if (res.status === 200 || res.status === 204) {
                await getAuthorityDetail();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <DeleteModalButton title="Delete Data" onClick={handleShow} />


            <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="md" centered>
                {/* ===== HEADER ===== */}
                <Modal.Header className="modern-modal-header delete-modal-header">
                    <div className="header-content">
                        <div className="header-icon-wrapper delete-icon-wrapper">
                            <Trash2 size={22} />
                        </div>
                        <div>
                            <Modal.Title>Delete Authority Detail</Modal.Title>
                            <p className="header-subtitle">This action cannot be undone</p>
                        </div>
                    </div>
                    <button type="button" className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                {/* ===== BODY ===== */}
                <Modal.Body className="modern-modal-body">
                    <div className="delete-confirm-wrap">
                        <div className="delete-warning-icon">
                            <AlertTriangle size={34} />
                        </div>

                        <h4 className="delete-confirm-title">
                            Are you sure you want to delete this authority?
                        </h4>
                        <p className="delete-confirm-subtitle">
                            This authority will be permanently removed from the system.
                        </p>

                        {(i?.bank_name || i?.designation) && (
                            <div className="delete-preview-card">
                                <div className="delete-preview-icon">
                                    <UserRound size={16} />
                                </div>
                                <div className="delete-preview-content">
                                    <div className="delete-preview-name">
                                        <span>{i?.bank_name || "Authority"}</span>
                                    </div>
                                    <div className="delete-preview-meta">
                                        {i?.designation && (
                                            <span className="delete-preview-chip">
                                                <BadgeCheck size={12} /> {i.designation}
                                            </span>
                                        )}
                                        {i?.mobile_no && (
                                            <span className="delete-preview-chip">
                                                <Phone size={12} /> {i.mobile_no}
                                            </span>
                                        )}
                                        {i?.email && (
                                            <span className="delete-preview-chip">
                                                <Mail size={12} /> {i.email}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="delete-warning-note">
                            <AlertCircle size={14} />
                            <span>This will permanently delete the authority detail.</span>
                        </div>
                    </div>
                </Modal.Body>

                {/* ===== FOOTER ===== */}
                <Modal.Footer className="modern-modal-footer">
                    <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                        Cancel
                    </button>
                    <button type="button" onClick={handleFormSubmitDelete} className="btn-danger-delete" disabled={loading}>
                        {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                        <span>{loading ? "Deleting..." : "Delete Authority"}</span>
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};


// const AuthorityDietails = () => {

//     const [buffer, setBuffering] = useState(true);

//     const [authorityDetail, setAuthorityDetail] = useState([])

//     const getAuthorityDetail = async () => {
//         setBuffering(true);
//         try {
//             const res = await axios.get(`${BASE_URL3}/project/authoritydetails/`);
//             setAuthorityDetail(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);
//         }
//     };

//     useEffect(() => {
//         getAuthorityDetail()
//     }, [])


//     return (
//         <>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             <div >
//                 <div className="attendance-box">
//                     <div className="datagrid-container">
//                         <div className="custom-table-background" style={{ height: "66vh" }}>
//                             <div className="">
//                                 <div className="">
//                                     <div className="table-box ">
//                                         <div className="flex-row table-heading" style={{ justifyContent: "end" }}>

//                                             <AddAuthorityDetail getAuthorityDetail={getAuthorityDetail} />
//                                         </div>
//                                     </div>
//                                     <div className='table-box scroll-container-table'
//                                     >
//                                         <table className="table-css width-100vw">
//                                             <thead className="table-heading">
//                                                 <tr className="custom-table-head-tr">
//                                                     <th className="table-heading ">S.no.</th>
//                                                     <th className="table-heading text-left">Name</th>
//                                                     <th className="table-heading text-left">Designation</th>
//                                                     <th className="table-heading text-left">Mobile no.</th>
//                                                     <th className="table-heading text-left">Email</th>
//                                                     <th className="table-heading text-center">Action</th>
//                                                 </tr>
//                                             </thead>
//                                             {buffer ? (

//                                                 <div className="spinner-bgdatil"></div>

//                                             ) :
//                                                 <tbody>
//                                                     {
//                                                         authorityDetail.map((i, index) => (
//                                                             <tr key={index} className="custom-table-head-td">
//                                                                 <td>{index + 1}.</td>
//                                                                 <td>{i.bank_name}</td>
//                                                                 <td>{i.designation}</td>
//                                                                 <td>{i.mobile_no}</td>
//                                                                 <td>{i.email}</td>
//                                                                 <td>
//                                                                     <div className='flex-row justify-center'>

//                                                                         <UpdateAuthorityDetail i={i} getAuthorityDetail={getAuthorityDetail} />
//                                                                         <DeleteAuthorityDetail i={i} getAuthorityDetail={getAuthorityDetail} />
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                         ))
//                                                     }
//                                                 </tbody>

//                                             }
//                                         </table>

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     )
// };


const AuthorityDietails = () => {
    const [buffer, setBuffering] = useState(true);
    const [authorityDetail, setAuthorityDetail] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const getAuthorityDetail = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL3}/project/authoritydetails/`);
            setAuthorityDetail(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getAuthorityDetail();
    }, []);

    const q = searchQuery.trim().toLowerCase();
    const filteredList = (authorityDetail || []).filter((a) => {
        if (!q) return true;
        return [a.bank_name, a.designation, a.mobile_no, a.email].some((v) =>
            String(v ?? "").toLowerCase().includes(q)
        );
    });

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="wt-page">
                <div className="wt-card">
                    {/* ===== HEADER ===== */}
                    <div className="wt-header">
                        <div className="wt-header-left">
                            <div className="wt-header-icon">
                                <UserRound size={20} />
                            </div>
                            <div>
                                <h4 className="wt-title">
                                    Authority Details
                                    <span className="wt-count">
                                        {searchQuery ? `${filteredList.length} / ${authorityDetail.length}` : authorityDetail.length}
                                    </span>
                                </h4>
                                <p className="wt-subtitle">Authorised persons and their contact details</p>
                            </div>
                        </div>

                        <div className="wt-header-right">
                            <div className="wt-search">
                                <Search size={16} />
                                <input
                                    type="text"
                                    placeholder="Search name, designation, email..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                {searchQuery && (
                                    <button
                                        type="button"
                                        className="wt-search-clear"
                                        onClick={() => setSearchQuery("")}
                                        title="Clear"
                                    >
                                        <X size={14} />
                                    </button>
                                )}
                            </div>
                            <AddAuthorityDetail getAuthorityDetail={getAuthorityDetail} />
                        </div>
                    </div>

                    {/* ===== TABLE ===== */}
                    <div className="wt-table-wrap">
                        <table className="wt-table">
                            <thead>
                                <tr>
                                    <th style={{ width: 70 }}>S.No.</th>
                                    <th>Name</th>
                                    <th>Designation</th>
                                    <th>Mobile No.</th>
                                    <th>Email</th>
                                    <th style={{ width: 140 }} className="wt-th-end">Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {buffer ? (
                                    <tr>
                                        <td colSpan={6}>
                                            <div className="wt-state">
                                                <div className="spinner-bgdatil"></div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : filteredList.length === 0 ? (
                                    <tr>
                                        <td colSpan={6}>
                                            <div className="wt-state">
                                                <UserRound size={30} />
                                                <p>{searchQuery ? "No matching authorities" : "No authority details added yet"}</p>
                                                <small>
                                                    {searchQuery
                                                        ? "Try a different search term"
                                                        : "Click the add button to create your first authority"}
                                                </small>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredList.map((i, index) => (
                                        <tr key={i.id || index}>
                                            <td className="wt-sno">{index + 1}.</td>
                                            <td className="wt-name">{i.bank_name || "-"}</td>
                                            <td>
                                                <span className="wt-chip">{i.designation || "-"}</span>
                                            </td>
                                            <td className="wt-mono">{Number(i.mobile_no).toFixed(0) || "-"}</td>
                                            <td>
                                                {i.email ? (
                                                    <a className="wt-link" href={`mailto:${i.email}`}>{i.email}</a>
                                                ) : "-"}
                                            </td>
                                            <td>
                                                <div className="wt-actions">
                                                    <UpdateAuthorityDetail i={i} getAuthorityDetail={getAuthorityDetail} />
                                                    <DeleteAuthorityDetail i={i} getAuthorityDetail={getAuthorityDetail} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AuthorityDietails